import geofenceApi from '@/api/geofence'

export const resetState = ({ commit }) => {
  commit('resetState')
}

export const loadNamedLocations = async ({ commit }, groupId) => {
    const { named_locations, alert_settings } = await geofenceApi.getAll(groupId)

    commit('setNamedLocations', named_locations)
    commit('setAlertSettings', alert_settings)
}

export const addNamedLocation = ({ commit }, named_locations) => {
  commit('addNamedLocation', named_locations)
}

export const updateNamedLocation = ({ commit }, named_locations) => {
  commit('updateNamedLocation', named_locations)
}

export const removeNamedLocation = ({ commit }, named_location_id) => {
  commit('removeNamedLocation', named_location_id)
}

export const updateAlertSettiings = ({ commit }, alert_settings) => {
  commit('updateAlertSettiings', alert_settings)
}

export const getLocationHistory = ({ commit }, data) => {
  const { user_id, page_size, max_date } = data

  return geofenceApi.getLocationHistory(user_id, page_size, max_date).then(data => {
    const { location_history } = data

    commit('setLocationHistory', location_history)

    return location_history
  })
}

export const clearLocationHistory = ({ commit }) => {
  commit('clearLocationHistory')
}

export const remove = ({ commit }, namedLocationId, groupId) => {
  return geofenceApi.remove(namedLocationId, groupId).then(() => {
    commit('removeNamedLocation', namedLocationId)
  })
}